import React from 'react';
import { Box } from '@vp/swan';
import type { UseFormReturn } from 'react-hook-form';
import { Field } from './Field';
import type { FieldFragment } from './brief.generated';

interface HiddenFieldsProps {
    hiddenFields: FieldFragment[];
    methods: UseFormReturn;
}

// "Hidden fields" are fields that are not displayed in the UI but needed to exist in the form of
// components. This is to execute logic on them, such as mutations that influence the rendering of
// other fields and therefore groups/steps.

// It is more ideal to set data explicitly/manually in `create` in cases where they render other
// fields - this is a TODO.

export default function HiddenFields(props: HiddenFieldsProps) {
    const { hiddenFields, methods } = props;

    const {
        register,
        setValue,
        formState: { errors: formErrors },
        clearErrors,
        setError,
    } = methods;

    if (!hiddenFields || hiddenFields.length === 0) {
        return null;
    }

    return (
        <Box id="hidden-fields" style={{ display: 'none' }}>
            {hiddenFields.map((f) => {
                return (
                    <Field
                        key={`form-field-${f.id}`}
                        register={register}
                        field={f}
                        error={formErrors[f.id]}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        setError={setError}
                        isOmitRequiredIndicator
                        isOverrideDisplayConfig
                    />
                );
            })}
        </Box>
    );
}
